import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import AdminLayout from './AdminLayout';
import supabase from '../../supabase/supabase';
import { assets } from '../../data/catalog';

const { FiSave, FiUpload, FiImage, FiCheck, FiRefreshCw } = FiIcons;

const DEFAULT_SECTIONS = [
  { key: 'hero_botanical', label: 'Hero Botanical Explosion', defaultUrl: assets.hero },
  { key: 'hibiscus_cluster', label: 'Hibiscus Luxury Cluster', defaultUrl: assets.hibiscusCluster },
  { key: 'lotus_bloom', label: 'Blue Lotus Royal Bloom', defaultUrl: assets.lotusBloom },
  { key: 'pea_wave', label: 'Butterfly Pea Indigo Wave', defaultUrl: assets.peaWave },
  { key: 'rose_swirl', label: 'Rose Petal Romantic Swirl', defaultUrl: assets.roseSwirl },
  { key: 'ingredient_circle', label: 'Botanical Ingredient Circle', defaultUrl: assets.ingredientCircle },
  { key: 'floating_elements', label: 'Floating Botanical Elements', defaultUrl: assets.floating },
  { key: 'corner_frame', label: 'Botanical Corner Frame', defaultUrl: assets.corner },
  { key: 'wellness_banner', label: 'Luxury Herbal Tea Banner', defaultUrl: assets.wellness },
  { key: 'signature_banner', label: 'Signature Collection Banner', defaultUrl: assets.signature }
];

function AdminLanding() {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState({});
  const [saved, setSaved] = useState({});

  useEffect(() => {
    const load = async () => {
      const { data } = await supabase.from('landing_content_1750000002').select('*');
      const map = {};
      (data || []).forEach((item) => { map[item.section_key] = item.image_url; });
      setContent(map);
      setLoading(false);
    };
    load();
  }, []);

  const updateUrl = (key, url) => {
    setContent((prev) => ({ ...prev, [key]: url }));
  };

  const handleFileUpload = (key) => (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => updateUrl(key, ev.target.result);
    reader.readAsDataURL(file);
  };

  const saveSection = async (key) => {
    setSaving((s) => ({ ...s, [key]: true }));
    const url = content[key] || '';
    await supabase.from('landing_content_1750000002').upsert(
      { section_key: key, image_url: url, updated_at: new Date().toISOString() },
      { onConflict: 'section_key' }
    );
    setSaving((s) => ({ ...s, [key]: false }));
    setSaved((s) => ({ ...s, [key]: true }));
    setTimeout(() => setSaved((s) => ({ ...s, [key]: false })), 2000);
  };

  if (loading) return <AdminLayout><div className="admin-loading">Loading…</div></AdminLayout>;

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div><h1>Landing Content</h1><p>Manage images and visual content on the landing page</p></div>
      </div>

      <div className="landing-grid">
        {DEFAULT_SECTIONS.map(({ key, label, defaultUrl }) => {
          const currentUrl = content[key] || defaultUrl;
          return (
            <div className="landing-card" key={key}>
              <div className="landing-card-preview">
                <img src={currentUrl} alt={label} />
              </div>
              <div className="landing-card-body">
                <h2>{label}</h2>
                <div className="landing-card-input-row">
                  <input value={currentUrl} onChange={(e) => updateUrl(key, e.target.value)} placeholder="Image URL" />
                  <label className="file-upload-btn compact">
                    <SafeIcon icon={FiUpload} />
                    <input type="file" accept="image/*" onChange={handleFileUpload(key)} hidden />
                  </label>
                </div>
                <button className="admin-btn primary" onClick={() => saveSection(key)} disabled={saving[key]}>
                  {saved[key] ? <><SafeIcon icon={FiCheck} /> Saved</> : saving[key] ? 'Saving…' : <><SafeIcon icon={FiSave} /> Save</>}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </AdminLayout>
  );
}

export default AdminLanding;